import React from 'react';
import { formatDateDayMonth } from '../../utils/dateFormat';

/**
 * THE two "changed since" badges of a manager person-week (owner 2026-10-29, approved mock panel 1):
 *   "Changed since submitted" — the server's `changed_since_submit` (a manager edited the week after
 *     it was submitted; cleared by a resubmit or a reopen);
 *   "Changed since export" — `export.changed_since_export_at` (the week moved after a payroll
 *     export; cleared by the next export of that week).
 * Each badge is WORDS in an outlined pill, never colour alone; its title says when. It decides
 * nothing — both flags are the server's, read off `managerPerson`.
 */
export const CHANGED_SUBMIT_PILL = 'border border-amber-400 bg-amber-50 text-amber-800 dark:border-amber-500/60 dark:bg-amber-900/30 dark:text-amber-200';
export const CHANGED_EXPORT_PILL = 'border border-rose-300 bg-rose-50 text-rose-800 dark:border-rose-500/60 dark:bg-rose-900/30 dark:text-rose-200';

export default function ChangedBadges({ person, compact = false }) {
  const sub = person && person.changed_since_submit;
  const exp = person && person.export && person.export.changed_since_export_at ? person.export : null;
  if (!sub && !exp) return null;
  const pill = 'ml-1 inline-block whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium';
  return (
    <>
      {sub && (
        <span data-testid={`person-changed-submit-${person.lineage_id}`} className={`${pill} ${CHANGED_SUBMIT_PILL}`}
          title={`Changed after it was submitted (last ${formatDateDayMonth(sub.at)}). Resubmit the week to clear this.`}>
          {compact ? 'Changed' : 'Changed since submitted'}
        </span>
      )}
      {exp && (
        <span data-testid={`person-changed-export-${person.lineage_id}`} className={`${pill} ${CHANGED_EXPORT_PILL}`}
          title={`Changed after the payroll export of ${formatDateDayMonth(exp.exported_at)}. Export it again to clear this.`}>
          {compact ? 'Since export' : 'Changed since export'}
        </span>
      )}
    </>
  );
}
